/* eslint-disable */
// import core & vendor packages below
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, OverlayTrigger, Popover, Row, Col, Pagination, Form } from 'react-bootstrap';

// import components below
import { patientStatus } from 'helpers';
import Table from 'components/ReactTable';
import TableUI from 'components/UI/TableUI';
import { selectPatientItem, showPatient } from 'reducers/patientReducer';

// import assets below
import './Table.scss';

// main component
const PatientTable = (data) => {
  const { state, setShowProfile } = data;
  // eslint-disable-next-line prefer-const
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const EditProfile = (item) => {
    setShowProfile((prevState) => {
      return {
        ...prevState,
        profileId: item?.id,
      };
    });

    dispatch(showPatient(item.id));
    navigate('/dashboard/outpatient-department/edit-patient-profile', { replace: true });
  };

  const tableColumns = React.useMemo(
    () => [
      { Header: 'ID', accessor: 'id' }, // accessor is the "key" in the data
      { Header: 'MRN / PIN', accessor: 'mrn' },
      { Header: 'Patient Name', accessor: 'name' },
      { Header: 'Priority', accessor: 'er_status' },
      { Header: 'Consulting Dept', accessor: 'hospital_service' },
    ],
    [],
  );

  const tableData = React.useMemo(
    () =>
      state?.map((dd) => ({
        id: dd?.id,
        mrn: dd?.MRN,
        name: dd?.full_name,
        er_status: dd?.er_status,
        hospital_service: dd?.hospital_service,
      })),
    [state],
  );

  const handleTableAction = (eventKey, id) => {
    const row = state.find((dd) => dd.id === id);
    const action = {
      profile: () => {
        setShowProfile((prevState) => {
          return {
            ...prevState,
            isShowView: true,
            profileId: row?.id,
          };
        });
      },
      view: () => {},
      edit: () => {},
    };

    action[eventKey]();
  };

  return (
    <div className='emergency-department-search-patient-table'>
      <Table
        data={tableData}
        columns={tableColumns}
        actions={{ hasProfile: true }}
        onAction={handleTableAction}
        pagination={['BOTTOM']}
      />
    </div>
  );
};

export default PatientTable;
